import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import Link from '@mui/material/Link'
import MenuItem from '@mui/material/MenuItem'
import { styled } from '@mui/material/styles'
import React from 'react'

type Option = {
  label: string
  value: string
}

type Props = {
  clearable?: boolean
  name?: string
  options: Option[]
  value: string[]
  onChange: (value: string[]) => void
}

const MultipleChoice = React.forwardRef<HTMLDivElement, Props>(
  ({ clearable = true, name, options, value, onChange }, ref) => {
    const handleChange = React.useCallback(
      (e: React.ChangeEvent<HTMLInputElement>) => {
        const v = e.target.value
        const index = value.indexOf(v)
        if (index === -1) {
          return onChange([...value, v])
        }
        return onChange(value.filter((item) => item !== v))
      },
      [value, onChange],
    )

    return (
      <div data-testid={`multiple-choice-${name}`} ref={ref}>
        {options &&
          options.map((option) => (
            <MenuItem disableGutters key={option.value} sx={{ p: 0 }} value={option.value}>
              <ChoiceLabel
                control={
                  <Checkbox checked={value.indexOf(option.value) !== -1} value={option.value} onChange={handleChange} />
                }
                label={option.label}
              />
            </MenuItem>
          ))}
        {clearable && (
          <ClearContainer>
            <Link component="button" variant="body2" onClick={() => onChange([])}>
              Clear selected
            </Link>
          </ClearContainer>
        )}
      </div>
    )
  },
)

const ClearContainer = styled('div')({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
})

const ChoiceLabel = styled(FormControlLabel)({
  margin: 0,
  padding: '6px 16px 6px 5px',
  width: '100%',
})

export default MultipleChoice
